import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

// 屏幕适配
import "lib-flexible/flexible";

Vue.config.productionTip = false;

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import locale from "element-ui/lib/locale/lang/zh-CN";
Vue.use(ElementUI, { size: "mdeium", locale });

import { InfiniteScroll } from "element-ui";
Vue.use(InfiniteScroll);

import "@/common/common.scss";
import "@/common/animate.min.css";
import "@/assets/font/font.css";

import minxin from "./mixin";
Vue.mixin(minxin);

// 引入 echarts 文件
import * as echarts from "echarts";
Vue.prototype.$echarts = echarts;

// js跨域请求插件
import { VueJsonp } from "vue-jsonp";
Vue.use(VueJsonp);

window.system = new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
